interface OrderDetailFields {
  clientSubmissionId?: string | null;
  notes?: string | null;
  sizeDescription?: string | null;
  description?: string | null;
}

const PLATFORM_PREFIXES = ["shopify", "woocommerce", "square", "lightspeed"];

const PLATFORM_REFERENCE = /^(shopify|woocommerce|square|lightspeed)\s+#*\S+$/i;

const text = (value?: string | null): string => String(value || "").trim();

/** Visible placeholder used when an order-details field has no value. */
export function displayOrDash(value?: string | number | null): string {
  if (value === null || value === undefined) {
    return "-";
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value) : "-";
  }
  const trimmed = value.trim();
  return trimmed ? trimmed : "-";
}

export function isPlatformOrder(order?: OrderDetailFields | null): boolean {
  const prefix = text(order?.clientSubmissionId).toLowerCase().split(":")[0];
  return PLATFORM_PREFIXES.includes(prefix) || PLATFORM_REFERENCE.test(text(order?.notes));
}

/** Package notes, hiding the "Shopify #1005" reference older imports stored there. */
export function displayPackageNotes(order?: OrderDetailFields | null): string {
  const notes = text(order?.notes);
  return notes && !PLATFORM_REFERENCE.test(notes) ? notes : "-";
}

/** Older platform imports kept the item list in the delivery notes field. */
export function displayItemDescription(order?: OrderDetailFields | null): string {
  const size = text(order?.sizeDescription);
  if (size) {
    return size;
  }
  if (isPlatformOrder(order)) {
    return text(order?.description) || "-";
  }
  return "-";
}

export function displayDeliveryNotes(order?: OrderDetailFields | null): string {
  if (isPlatformOrder(order) && !text(order?.sizeDescription)) {
    return "";
  }
  return text(order?.description);
}
